import React  , {useContext , useEffect , useState} from 'react'
import CartContext from '../../../../context/cart_context'
import RestaurentContext from '../../../../context/rest_context';
import "./restaurentAlert.css";
import RestaurentModel from '../../../../models/Restaurent_model';
import {useLocation} from "react-router-dom";



import "./restaurentAlert.css"
import { LoadingSpinner } from '../../../../components/mini-components/mini-components';
import { get, ref } from 'firebase/database';
import { db } from '../../../../config/firebase_config';

const RestaurentAlert = () => {
  
const {setShowAlert , selectedRest ,seletedFoodItem, setSeletedFoodItem  , newCart} = useContext(CartContext);
const {tappedStore, setTappedStore} = useContext(RestaurentContext);

const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const storeID = queryParams.get('storeID');

useEffect(() => {
    
  const getRestData = async() => {
    
    const dbRestRef = ref(db, `RestaurantMenu/${storeID}`);
      const restSnap = await get(dbRestRef);
      if (restSnap.exists()) {
        const data = restSnap.val();
        console.log( "<--- rest comp data  --->" , data , storeID);
        const restItem = RestaurentModel.fromJson( storeID , data);
        setTappedStore(restItem);
      }
  }

  if(tappedStore == null){
    getRestData();
  }

}, [])



  return (
    <div className='alert-box-bg'>
        <div className='alert-box-container' >
          {
            tappedStore == null 
            ? <LoadingSpinner/>
            :
            <>
                <h3>Replace Cart Item ?</h3>
                <p>Your cart Contains dishes from <span>{selectedRest.name}</span> . </p>
                <p>Do you want to discard the selection and add dishes from <span> {tappedStore.name} </span> </p>
                <div className='select-options'>
                    <button className='select-no' onClick={() => {
                      setShowAlert(false) ;
                      setSeletedFoodItem(null);
                    } } >No</button>
                    <button  onClick={() => {
                      setShowAlert(false) ;
                      newCart(seletedFoodItem , 1);
                      setSeletedFoodItem(null);
                    }} >Yes</button>
              </div>
            </>
          }
            
        </div>
    </div>
  )
}

export default RestaurentAlert